<template>
	<div class="w-100 overflow-hidden">
		<div class="col-12 pb-3">
			<div class="w-100 border-15 bg-white p-3 shadow overflow-hidden">
				<p class="bMikhak">
					{{title}}
				</p>
				<span
				v-for="(f, i) in flds" :key="i" >
					<btn 
					type="outline-light-green" 
					class="float-right ml-3 mb-3"  
					:text="f.name" 
					v-if="router==''" 
					/>
					<router-link
					:to="router.replace(':id', f.id)" 
				v-else
				>
					<btn 
					type="outline-light-green" 
					class="float-right ml-3 mb-3" 
					:text="f.name" 
					/>
				</router-link>
			</span>
			</div>
		</div>
	</div>
</template>

<script>
	import btn from  "../button/btn.vue";
	export default {
		name: 'title_list',
		data(){
			return {
			}
		},
		components: {
				btn,
		},
		props: {
			flds: {
				default: [],
			},
			title: {
				default: "",
			},
			router:{
				default: "",
			}
		},
		mounted(){

		},
		methods:{

		}
	}
</script>
<style>

</style>
